import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c9e7c662&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e7c662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e7c662')) {
      api.createRecord('c9e7c662', component.options)
    } else {
      api.reload('c9e7c662', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c9e7c662&scoped=true&", function () {
      api.rerender('c9e7c662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-269j70cbrGQEr/JS/comp/Accordion.vue"
export default component.exports